import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import welcome from '../assets/images/welcome.png';

const Confirmation = () => {
  const navigate = useNavigate();

  const params = new URLSearchParams(window.location.search);
  const fullname = params.get('fullname');
  const email = params.get('email');
  const account = params.get('account');
  const token = params.get('token');
  const currency = params.get('currency');
  const country = params.get('country'); // Assuming the country parameter is part of the query

  const [isAccountValid, setIsAccountValid] = useState(false);

  useEffect(() => {
    const validateAccount = () => {
      // Check if the account starts with CR, currency is USD, and country is KE
      if (account.startsWith('CR') && currency === 'USD' && country === 'ke') {
        setIsAccountValid(true);
      } else {
        setIsAccountValid(false);
        toast.error(
          'Kindly complete your sign-up on Deriv to get a Real USD account in Kenya, then come back.',
          { autoClose: 2500 }
        );
        setTimeout(() => {
          toast.dismiss(); // Explicitly dismiss the toast
          navigate('/signin');
        }, 2500); // Redirect to sign-in after 2.5 seconds
      }
    };

    validateAccount();
  }, [account, currency, country, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-gray-50">
      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar
        closeOnClick={false} // Prevent the toast from closing on click
        pauseOnHover={false} // Disable hover pause
        draggable={false} // Disable dragging of toast
      />

      <header className="bg-teal-600 w-full p-4 text-white text-center text-2xl font-bold">
        Confirmation
      </header>

      <div className="w-full max-w-lg bg-white rounded-lg shadow-md p-6 text-center mt-4 lg:mt-8">
        <img src={welcome} alt="Welcome" className="mx-auto mb-6 w-3/4 sm:w-1/2 md:w-1/3 lg:w-1/4" />

        <h1 className="text-2xl sm:text-3xl font-bold mb-4">Welcome!</h1>

        <p className="text-base sm:text-lg mb-4">
          You have successfully signed in to Deriv. Please confirm that these are your details.
        </p>

        <div className="text-lg font-semibold mb-2 text-gray-800">{fullname?.toUpperCase()}</div>
        <div className="text-gray-700 mb-2">{email}</div>
        <div className="text-gray-700 mb-4">{account}</div>

        {/* These are my details button */}
        <button
          onClick={() => navigate('/phone_number', { state: { fullname, email, account, token } })}
          className={`w-full py-2 rounded-md text-lg font-semibold mb-3 transition ${
            isAccountValid
              ? 'bg-teal-600 text-white hover:bg-teal-700'
              : 'bg-gray-400 text-gray-700 cursor-not-allowed'
          }`}
          disabled={!isAccountValid}
        >
          These are my details!
        </button>

        {/* Not my details button */}
        <button
          onClick={() => navigate('/signup')}
          className={`w-full py-2 rounded-md text-lg font-semibold transition ${
            isAccountValid
              ? 'text-teal-600 hover:text-teal-800'
              : 'text-gray-500 cursor-not-allowed'
          }`}
          disabled={!isAccountValid}
        >
          Not my details!
        </button>
      </div>
    </div>
  );
};

export default Confirmation;
